import { jsxs as l, jsx as a, Fragment as m } from "react/jsx-runtime";
import e from "./trailer-rental-summary.module.less.js";
import { capitalizeFirstLetter as n } from "../../../../../helpers/text-helper.js";
import "dayjs";
import { useTranslation as h } from "react-i18next";
const p = ({ trailer: s, station: r, fromSlot: d, toSlot: c }) => {
  const { t: i } = h();
  return /* @__PURE__ */ l("div", { className: e.wrapper, children: [
    /* @__PURE__ */ a("h5", { children: i("SUMMARY") }),
    /* @__PURE__ */ l("div", { className: e.innerWrapper, children: [
      /* @__PURE__ */ l("div", { className: e.label, children: [
        i("TRAILER_RENTAL_TRAILER_TYPE"),
        ":"
      ] }),
      /* @__PURE__ */ a("div", { className: e.details, children: /* @__PURE__ */ a("span", { className: e.bold, children: n(s.alias ?? s.freeText ?? s.title) }) }),
      /* @__PURE__ */ l("div", { className: e.label, children: [
        i("TRAILER_RENTAL_STATION_SEARCH_LABEL"),
        ":"
      ] }),
      /* @__PURE__ */ l("div", { className: e.details, children: [
        /* @__PURE__ */ a("span", { className: e.bold, children: r.name }),
        /* @__PURE__ */ l("span", { children: [
          r.address,
          ", ",
          r.city
        ] }),
        r.phone && /* @__PURE__ */ a("a", { href: `tel:${r.phone}`, children: r.phone })
      ] }),
      d && /* @__PURE__ */ l(m, { children: [
        /* @__PURE__ */ l("div", { className: e.label, children: [
          i("TRAILER_RENTAL_SEARCH_STARTDATE_LABEL"),
          ":"
        ] }),
        /* @__PURE__ */ a("div", { className: [e.details, e.bold].join(" "), children: d.format("D MMMM, YYYY [kl] HH:mm") })
      ] }),
      c && /* @__PURE__ */ l(m, { children: [
        /* @__PURE__ */ l("div", { className: e.label, children: [
          i("TRAILER_RENTAL_SEARCH_ENDDATE_LABEL"),
          ":"
        ] }),
        /* @__PURE__ */ a("div", { className: [e.details, e.bold].join(" "), children: c.format("D MMMM, YYYY [kl] HH:mm") })
      ] })
    ] })
  ] });
};
export {
  p as TrailerRentalSummary
};
